import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import LinkButton from 'flarum/common/components/LinkButton';
import Dropdown from 'flarum/common/components/Dropdown';
export { default as extend } from './extend';
app.initializers.add('devconnect-portal-navigation', () => {
  // Главное меню остаётся штатным HeaderPrimary и получает только продуктовые разделы DevConnect.
  extend(HeaderPrimary.prototype, 'items', function (items) {
    // External включает обычную навигацию к SSR-маршрутам, а LinkButton
    // сохраняет совместимость vnode с ItemList штатной шапки Flarum.
    items.add('devconnect-forum', m(LinkButton, {
      href: '/all',
      external: true
    }, 'Обсуждения'), 100);
    items.add('devconnect-articles', m(LinkButton, {
      href: '/articles',
      external: true
    }, 'Статьи'), 90);
    items.add('devconnect-guides', m(LinkButton, {
      href: '/guides',
      external: true
    }, 'Гайды'), 80);
    items.add('devconnect-tools', m(LinkButton, {
      href: '/tools',
      external: true
    }, 'Инструменты'), 70);
  });

  // На планшетах полное меню заменяется одним штатным доступным Dropdown.
  extend(HeaderSecondary.prototype, 'items', function (items) {
    items.add('devconnect-compact-menu', m(Dropdown, {
      className: 'dc-compact-menu',
      buttonClassName: 'Button Button--flat',
      label: 'Разделы',
      icon: 'fas fa-bars'
    }, [m(LinkButton, {
      href: '/all',
      external: true
    }, 'Обсуждения'), m(LinkButton, {
      href: '/articles',
      external: true
    }, 'Статьи'), m(LinkButton, {
      href: '/guides',
      external: true
    }, 'Гайды'), m(LinkButton, {
      href: '/tools',
      external: true
    }, 'Инструменты')]), 90);
  });
});